import type { FC } from 'react';

interface HeaderProps {
  total?: number;
  title: string;
  description: string;
}

export const Header: FC<HeaderProps> = ({ total, title, description }) => {
  return (
    <>
      <div className="text-text300 font-poppins">
        <span className="text-base font-semibold md:text-xl">{title}</span>{' '}
        {Boolean(total) && (
          <span className="text-sm font-normal md:text-base">({total})</span>
        )}
      </div>
      <p className="font-poppins text-text600 w-[80%] text-xs font-normal md:w-full">
        {description}
      </p>
    </>
  );
};
